<div class="container-fluid loader_container" *ngIf="_apiService.is_loading">
    <div class="dashboard-wrapper">
        <div class="loading"></div>
    </div>
</div>